export default __webpack_public_path__ + "static/media/banner6.9822d994.png";